module.exports = __webpack_public_path__ + "static/media/STPLong1w522@1x.099a1f7a.webp";